import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FinalExitQueueList from "./FinalExitQueueList";
import { getMobilization } from "../../../../../store/Api";
import { useState } from "react";
import nodeinstance from "../../../../../nodeInstance";
import { setAppError } from "../../../../../store/userSlice";

export default function FinalExitQueueTab() {
 

  const token = localStorage.getItem("nodeToken");

  const dispatch = useDispatch();
 

  const [searchData, setSearchData] = useState([]);

  const getFinalExitData = async () => {
    try {
      const response = await nodeinstance.get(
        `/mobilization/finalExitFormalitiesQueueDays`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setSearchData(response.data);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };
  useEffect(() => {
    // dispatch(getMobilization(token));
    getFinalExitData();
  }, []);
  const updateApi = () => {
    // dispatch(getMobilization(token));
    getFinalExitData();
  };
  console.log("Data log in console",searchData)
  return (
    <div className={`p-2 `}>
      <FinalExitQueueList
        list={searchData}
        titles={[
          "S.NO.",
          "POINT OF HIRE",
          "EMPLOYEE ID",
          "EMPLOYEE NAME",
          "NATIONALITY",
          "ACTUAL PROFESSION",
          "VISA PROFESSION",
          "BASIC",
          "SALARY",
          "TOTAL SALARY",
          "CLIENT",
          "VISA PROVIDER",
          "IQAMA NUMBER",
          "IQAMA EXPIRY DATE",
          "STATUS",
          // "FINAL EXIT",
          "ISSUE DATE",
          "FINAL EXIT EXPIRY DATE",
          "PENDING DAYS FOR EXIT EXPIRY",
          "EXIT FROM COUNTRY DATE",
          "NAKAL KAFALA EXIT DATE",
          "DOCUMENT STATUS",
          "ACTION",
        ]}
        token={token}
        updateData={updateApi}
      />
    </div>
  );
}
